import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';

const { spacing } = dggTheme;

export const container = css`
  background-color: var(--dgg-moody-blue);
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 2;
  top: 0;
  right: 0;
  overflow: auto;
`;

export const modalContent = css`
  max-width: ${pxToRem(1440)};
  position: relative;
  margin: 0 auto;
  padding: ${pxToRem(80)} ${pxToRem(24)};
`;

export const closeBtn = css`
  position: absolute;
  z-index: 2;
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  right: ${pxToRem(spacing.xxl)};
  top: ${pxToRem(spacing.xxl)};
  background-color: var(--dgg-moody-blue);
  display: flex;
`;

export const iconContainer = css`
  margin: auto;
`;
